var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "90c0b24b-4604-4340-8f53-0da52969ce08"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "17f1c5bc-25cc-44d7-b362-1934e8ffe45b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(45 0 0 45 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -12)",
    d: "M 9 19.5 C 8.033225545421196 19.499723857625085 7.249723857625085 18.715774454578803 7.25 17.749000000000002 C 7.250276142374915 16.7822255454212 8.034225545421197 15.998723857625084 9.001 15.999 C 9.967774454578803 15.999276142374915 10.751276142374914 16.783225545421196 10.751 17.75 C 10.750723857625085 18.716774454578804 9.966774454578804 19.500276142374915 9.000000000000002 19.5 M 22.25 16 L 13.929 16 C 13.205 13.966000000000001 11.283000000000001 12.5 9 12.5 C 6.716999999999999 12.5 4.795 13.966 4.071 16 L 1.75 16 C 0.7835016877961114 16 0 16.78350168779611 0 17.75 C 0 18.71649831220389 0.7835016877961114 19.5 1.75 19.5 L 4.071 19.5 C 4.795 21.534 6.717 23 9 23 C 11.283000000000001 23 13.205 21.534 13.929 19.5 L 22.25 19.5 C 23.21649831220389 19.5 24 18.71649831220389 24 17.75 C 24 16.78350168779611 23.21649831220389 16 22.25 16 M 15 4.5 C 15.966774454578804 4.500276142374915 16.750276142374915 5.284225545421195 16.75 6.250999999999999 C 16.749723857625085 7.217774454578802 15.965774454578805 8.001276142374914 14.999000000000002 8.001 C 14.032225545421197 8.000723857625085 13.248723857625086 7.216774454578804 13.249 6.25 C 13.249276142374915 5.283225545421196 14.033225545421198 4.499723857625084 15 4.5 M 1.75 8 L 10.071 8 C 10.795 10.033999999999999 12.716999999999999 11.5 15 11.5 C 17.283 11.5 19.205 10.034 19.929000000000002 8 L 22.250000000000004 8 C 23.216498312203893 8 24.000000000000004 7.216498312203889 24.000000000000004 6.25 C 24.000000000000004 5.283501687796111 23.216498312203893 4.5 22.250000000000004 4.5 L 19.929000000000002 4.5 C 19.205 2.466 17.283 1 15 1 C 12.716999999999999 1 10.795 2.466 10.071 4.5 L 1.75 4.5 C 0.7835016877961114 4.5 0 5.283501687796111 0 6.25 C 0 7.216498312203889 0.7835016877961114 8 1.75 8",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.5be903048394a6421fdafb5ab3b92dd3.svg";
export { ForwardRef as ReactComponent };